import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { StorageMap } from '@ngx-pwa/local-storage';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	userAuthHttpOptions: any;
	isLoggedIn = false;
	isAuthed = false;
	private _userDetail;
	redirectUrl: string;
	constructor(private http: HttpClient, private localStorage: StorageMap) { }

	setHeaders(): void {
		this.isAuthed = true;
		this.userAuthHttpOptions = {
			headers: new HttpHeaders().set('Content-Type', 'application/json').set('x-lwrf-appid', 'ios-01')
		};
	}

	saveUserDetail(user): void {
		this.userDetail = user;
		this.localStorage.set("userDetail", user).subscribe();

	}

	get userDetail() {
		if(this._userDetail){
		return this._userDetail;
		}
	}

	set userDetail(user){
		this._userDetail = user;
	}

	login(username, password, mfaCode?: string): Observable<any> {
    this.setHeaders();
    const body: any = { email: username, password };
    if (mfaCode) {
      body.mfa_code = mfaCode;
    }
		return this.http.post<any>(environment.clientAuthUrl, body, this.userAuthHttpOptions);
	}

  loginAs(adminEmail, username, password, mfaCode?: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-lwrf-appid': 'ios-01'
      })
    };

    const body: any = {
      email: adminEmail,
      password: password,
      version: '1.0.0',
      loginAsEmail: username
    };

    if (mfaCode) {
      body.mfa_code = mfaCode;
    }

    const url = 'https://auth.lightwaverf.com/v3/lightwaverf/autouserlogin-as/lwapps';

    return this.http.post<any>(url, body, options);
  }

	logout(): void {
		this.isLoggedIn = false;

	}
}
